<template>
  <span @click='addToFavorites($event)'>
    <i :class="{'in': isFavorited, 'entity-list-card__to-favorite': !iscard}">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="20"
        height="18" viewBox="0 0 21 20" src="/t/dk/i/icons/star.svg?178528e0ec" class="svg">
        <g fill="none" stroke="#ff6659" transform="translate(0,1)">
          <path d="M9.998,0.000 L13.088,5.925 L19.999,6.876 L14.999,11.487 L16.179,18.000 L9.998,14.925 L3.817,18.000 L4.998,11.487 L-0.003,6.876 L6.909,5.925 L9.998,0.000 Z"></path>
        </g>
      </svg>
    </i>
    <span class="show-for-medium" v-if="iscard">
      <span v-if="isFavorited">Убрать из избранного</span>
      <span v-else>Добавить в избранное</span>
    </span>
  </span>
</template>

<script>
export default {
  name: 'Favorite',
  props: ['id', 'estate_group', 'estate_type', 'iscard', 'deletable'],
  data: function() {
      return {
          isFavorited: ''
      }
  },

  mounted() {
      this.isFavorited = this.isFavorite;
      this.$store.subscribe((mutation, state) => {
        this.isFavorited = this.isFavorite;
      });
  },

  computed: {
      isFavorite() {
          return this.inFavorites();
      },
      obj() {
        return {
          id: this.id,
          estate_group: this.estate_group,
          estate_type: this.estate_type,
        }
      }
  },

  methods: {
      inFavorites(){
        // const record = this.$store.state.added.find(f => f.id === this.obj.id)
        const record = this.$store.state.added.find(f => (f.id === this.obj.id && f.estate_group ===  this.obj.estate_group && f.estate_type ===  this.obj.estate_type))
        return !!record;
      },
      addToFavorites(){
        // this.$store.commit('ADD_TO_FAVORITES', obj)
        this.$store.dispatch('addToFavorites', this.obj);
        this.isFavorited = this.inFavorites();
        this.putToServer();
        if(this.deletable && !this.isFavorited){
          let papa = this.$el.closest('.entity-list-card');
          if (!papa) {
            papa = this.$el.closest('.housing-list-card');
          }
          if (papa) {
            // papa.classList.add('hide');
            papa.remove();
          }
        }
      },
      putToServer(){
        // console.log('Favorites', this.$store.getters.favoritesEstates);
        let url = '/catalog/ajax';
        let data = new FormData();
            data.append( "dkfavorites", JSON.stringify( this.$store.state.added ) );

        let promise = fetch(url, {
          // headers: {
            // 'Accept': 'application/json',
            // 'Content-Type': 'application/json',
            // 'Authorization': 'Basic YWRtMW46cnRxbGpy',
            // 'X-Requested-With': 'XMLHttpRequest'
          // },
          method: "POST",
          credentials: 'include',
          // credentials: 'same-origin',
          mode : 'no-cors',
          body: data
        });
            promise
              .then(data => {
                if (data.ok) {
                  return data.json()
                }
                throw new Error('Network response was not ok.')
              })
              .then(data => {
                //...
                console.log('favsrv', data);
                if(!document.getElementById("dkfavoritesList").getElementsByTagName('*').length){
                  location.href = '/catalog/favorites'
                }
              })
              .catch(error => {
                // console.log(error.message);
              });
      }
    }
}
</script>

<style lang="scss">
  .tofavorite,
  .entity-list-card__to-favorite {

    cursor: pointer;

    .svg g {
      fill: #e2e2e2;
      stroke: #e2e2e2;
    }

    .in .svg g path,
    &.in .svg g path{
      fill: #ff6659 !important;
      stroke: #ff6659 !important;
    }

    &:hover .svg g {
      fill: #ff6660 !important;
      stroke: #ff6660 !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Favorite.vue